<div class="flex flex-col justify-center items-center mt-44">
  <img src="/assets/images/offers/change-biller-offer-3.svg" />

  <div class="mt-44 items-center">
    Nasi eksperci przygotują dla Ciebie ofertę i skontaktują się z Tobą telefonicznie.
  </div>
</div>

<mat-dialog-actions align="start">
  <button color="primary" mat-raised-button mat-dialog-close="true">Zakończ</button>
</mat-dialog-actions>
